module.exports = __webpack_public_path__ + "static/media/banner-photo526@3x.43ca9562.jpg";